/* ALIO Theme JS */
(function () {

  /* --- Scroll reveal --- */
  var reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      obs.observe(el);
    });
  }

  /* --- Header scroll state --- */
  var header = document.querySelector('header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.style.backdropFilter = 'blur(12px)';
        header.style.boxShadow = '0 1px 20px rgba(10,10,10,0.06)';
      } else {
        header.style.backdropFilter = '';
        header.style.boxShadow = '';
      }
    }, { passive: true });
  }

  /* --- Mobile nav toggle --- */
  var mobileToggle = document.getElementById('mobile-menu-toggle');
  var mobileNav = document.getElementById('mobile-menu');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileNav.style.display === 'flex';
      mobileNav.style.display = open ? 'none' : 'flex';
    });
  }

  /* --- Ticker clone for seamless loop --- */
  var track = document.getElementById('ticker-track');
  if (track) {
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.parentNode.appendChild(clone);
  }

  /* --- Variant button selection on PDP --- */
  document.querySelectorAll('.variant-btn-group').forEach(function (group) {
    group.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('button').forEach(function (b) {
          b.style.background = 'transparent';
          b.style.color = '#0a0a0a';
        });
        btn.style.background = '#0a0a0a';
        btn.style.color = '#f5f4f0';
      });
    });
  });

  /* --- Add to cart feedback --- */
  document.querySelectorAll('form[action="/cart/add"] button[type="submit"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var orig = btn.textContent;
      btn.textContent = 'Added ✓';
      setTimeout(function () { btn.textContent = orig; }, 2500);
    });
  });

})();
